import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from "react-router-dom"
import { setPathname } from '../redux/slices/globalSlice'

const Page = ({
  children,
}) => {
  const dispatch = useDispatch()
  const { pathname } = useLocation()
  const globalPathname = useSelector(({ global }) => global.pathname)

  useEffect(() => {
    window.scrollTo({ top: 0 })
    dispatch(setPathname(pathname))
  }, [pathname])

  if (!globalPathname) return null

  return children
}

export default Page